module.exports = __webpack_public_path__ + "media/images/icon-map-candidate-a40c5a3562d37b796a623fd1932cfb8e.png";